import Responsive from "components/Responsive";
import useMediaQuery from "hooks/useMediaQuery";
import { Text } from "iparque-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { animationMediaQueryConfig } from "../helper";
import {
  HeadingContainer,
  InfoContainer,
  Square,
  StyledContentContainer,
  StyledHeading,
  StyledParkingMeterLogo,
} from "./styles";

interface Props {
  isOnScreen: boolean;
}

const ParkingMeterInfo: React.FC<Props> = ({ isOnScreen }) => {
  const { t } = useTranslation();
  const shouldDisplayAnimation = useMediaQuery(animationMediaQueryConfig);

  const keyPoints = [
    {
      text: t(
        "10509"
      ) /* Rentabilização extra através da colocação de publicidade digital */,
      isInAnimation: false,
    },
    {
      text: t("10510") /* Informação centralizada em tempo real */,
      isInAnimation: true,
    },
    {
      text: t("10428") /* Redução de custos de manutenção */,
      isInAnimation: true,
    },
    {
      text: t("10511") /* Autodiagnóstico de avarias na consola local */,
      isInAnimation: true,
    },
    {
      text: t("10432") /* Painel Solar de alto rendimento */,
      isInAnimation: true,
    },
    {
      text: t("10512") /* Ecrã touch de alta qualidade e a cores */,
      isInAnimation: true,
    },
    {
      text: t("10513") /* Baixo consumo energético */,
      isInAnimation: true,
    },
    {
      text: t(
        "10514"
      ) /* Múltiplos métodos de pagamento: Moedas / VISA / Mastercard / MB WAY / Google Pay / Apple Pay */,
      isInAnimation: true,
    },
    {
      text: t("10429") /* Configuração remota */,
      isInAnimation: true,
    },
    {
      text: t(
        "10515"
      ) /* Personalização do parquímetro por cor, para uma melhor integração na cidade */,
      isInAnimation: true,
    },
    {
      text: t("10516") /* Múltiplos idiomas */,
      isInAnimation: true,
    },
    {
      text: t(
        "10430"
      ) /* Certificado pelo Instituto Português da Qualidade e Associação Nacional de Segurança Rodoviária */,
      isInAnimation: false,
    },
    {
      text: t("10431") /* Linha de apoio/assistência técnica (09h00/20h00) */,
      isInAnimation: false,
    },
  ];

  return (
    <StyledContentContainer isOnScreen={isOnScreen}>
      <Responsive {...animationMediaQueryConfig} inverted>
        <StyledParkingMeterLogo
          preserveAspectRatio="xMinYMax meet"
          isOnScreen={isOnScreen}
        />
      </Responsive>
      <HeadingContainer id="title">
        <Square />
        <StyledHeading elementType="h2" color="secondary">
          iParque Street
          <br />
          i1T-EVO
        </StyledHeading>
      </HeadingContainer>
      <InfoContainer>
        <Text variant="body5" color="quintenary">
          <p id="text">
            {
              t(
                "10426"
              ) /* O parquímetro i1T – EVO é um terminal avançado, preparado para os desafios atuais dos centros urbanos. Tenha acesso a todos os indicadores de estacionamento em tempo real através do sistema de gestão iParque! */
            }
          </p>
          <div id="list">
            <b>
              {
                t(
                  "10427"
                ) /* Conheça as caraterísticas do parquímetro i1T- EVO, que se destaca de todas as outras soluções do mercado: */
              }
            </b>
            <ul>
              {keyPoints.map(
                (keyPoint) =>
                  (!shouldDisplayAnimation || !keyPoint.isInAnimation) && (
                    <li key={keyPoint.text}>{keyPoint.text}</li>
                  )
              )}
            </ul>
          </div>
        </Text>
      </InfoContainer>
    </StyledContentContainer>
  );
};

export default ParkingMeterInfo;
